import styled from '@emotion/styled';
import { BreadcrumbItem } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledBreadcrumbItem = styled(BreadcrumbItem)`
  font-size: 14px;
  text-transform: capitalize;
  color: ${COLORS.neutral3};
  svg {
    height: 25px;
    width: 25px;
    color: ${COLORS.neutral3};
    margin: -2px 8px !important;
  }
`;
